import AutoBetSettings from './AutoBetSettings';
export default AutoBetSettings;